<template>
    <div id="set-flex-channels">
        <div class="lg:flex items-center text-sm font-semibold mt-xl md:mt-0">
            <div class="w-full lg:w-1/2">
                {{ lang('Valbara kanaler','Selectable channels') }}
            </div>
            <div class="lg:flex items-center w-full lg:w-1/2 relative">
                <div>
                    {{ selectedChannels.length }}/{{ maxFlexChannels }} {{ lang('valda','selected') }}
                </div>
                <button
                    type="button"
                    class="btn btn-sm is-primary lg:ml-lg"
                    :class="{ 'is-active' : toggled }"
                    @click="toggle"
                >
                    {{ lang('Välj flex-kanaler','Select flex channels') }}
                </button>
                <a
                    :class="{ 'is-active' : toggled }"
                    class="absolute pin-t pin-r text-neutral-darker"
                    @click="toggle"
                >
                    <font-awesome-icon :icon="toggled ? 'chevron-up' : 'chevron-down'" class="chevron text-sm" />
                </a>
            </div>
        </div>

        <div v-if="toggled" class="text-sm text-neutral-dark mt-2xl mb-lg md:mb-xl">
            <div
                v-if="! canChangeFlexChannels"
                class="bg-neutral-lighter rounded-lg my-xl py-md px-lg flex items-center justify-start"
            >
                <font-awesome-icon icon="lightbulb" />
                <div class="text-sm ml-xl font-semibold">
                    {{ lang(
                        'Du kan välja nya flex-kanaler ',
                        'You can select new flex channels '
                    ) + canChangeFlexChannelsDate }}
                </div>
            </div>
            <h4>{{ lang('TV-kanaler','TV channels') }}</h4>
            <div class="flex flex-wrap channels max-w-xl">
                <option-box-checkbox
                    v-for="channel in sdChannels"
                    :key="channel.ataio_id"
                    v-model="selectedChannels"
                    :value="channel.ataio_id"
                    additional-class="channel with-checkbox"
                    :disabled="channelIsDisabled(channel)"
                >
                    <div>
                        <div
                            v-tooltip.top="channel.name"
                            class="image"
                        >
                            <img :src="channel.image" :alt="channel.name">
                        </div>
                    </div>
                </option-box-checkbox>
            </div>

            <h4 class="mt-lg">{{ lang('HD-kanaler','HD channels') }}</h4>
            <div class="flex flex-wrap channels max-w-xl">
                <option-box-checkbox
                    v-for="channel in hdChannels"
                    :key="channel.ataio_id"
                    v-model="selectedChannels"
                    :value="channel.ataio_id"
                    additional-class="channel with-checkbox"
                    :disabled="channelIsDisabled(channel)"
                >
                    <div>
                        <div
                            v-tooltip.top="channel.name"
                            class="image"
                        >
                            <img :src="channel.image" :alt="channel.name">
                        </div>
                        <div v-if="channel.title" class="text-xs font-semibold mt-sm">
                            {{ channel.title }}
                        </div>
                        <div v-if="channel.title" class="text-sm text-neutral-dark">
                            {{ channel.price }}
                        </div>
                    </div>
                </option-box-checkbox>
            </div>
            <div
                class="mt-2xl flex flex-col md:flex-row-reverse md:justify-between"
            >
                <button
                    class="btn btn-md is-primary mb-lg md:mb-0"
                    :class="{ 'is-loading': loading }"
                    :disabled="! canChange"
                    @click="submit"
                >
                    {{ lang('Spara ändringar','Save changes') }}
                </button>
                <button
                    type="button"
                    class="btn is-ghost btn-md"
                    @click="toggle"
                >
                    {{ lang('Avbryt','Cancel') }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            customerTvPackage: {
                type: Object,
                required: true,
            },
            channels: {
                required: true,
                type: Array,
            },
            maxFlexChannels: {
                type: Number,
                default: 8,
            },
            initialSelectedChannels: {
                type: Array,
                required: true,
            },
            canChangeFlexChannels: {
                type: Boolean,
                required: true,
                default: false,
            },
            canChangeFlexChannelsDate: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                loading: false,
                toggled: false,
                selectedChannels: this.initialSelectedChannels,
            };
        },
        computed: {
            sdChannels() {
                return this.channels.filter((channel) => ! channel.pivot.is_hd);
            },
            hdChannels() {
                return this.channels.filter((channel) => channel.pivot.is_hd);
            },
            canChange() {
                return ! this.loading && this.canChangeFlexChannels;
            },
        },
        methods: {
            toggle() {
                this.toggled = ! this.toggled;
            },
            channelIsDisabled(channel) {
                if (! this.canChangeFlexChannels) {
                    return true;
                }

                const found = this.selectedChannels.indexOf(channel.ataio_id);

                if (found !== -1) {
                    return false;
                }

                return this.selectedChannels.length >= this.maxFlexChannels;
            },
            async submit() {
                this.loading = true;

                try {
                    await axios.post(this.route('front.my-pages.api.tv.set-flex-channels', this.customerTvPackage), {
                        flexChannels: this.selectedChannels,
                    });

                    window.location.reload();

                } catch (e) {
                    flash_error(lang('Det gick tyvärr inte att spara ändringarna 😢','Changes could not be saved 😢'));
                    this.loading = false;
                }
            },
        },
    };
</script>